const checkboxTemplate = `<div class="variant-upsells__item-wrap" data-variant-upsell>
<input class="variant-upsells__checkbox" type="checkbox" data-upsell-checkbox value="{{ID}}" id="upsell-{{ID}}" />
  <a href="{{URL}}" class="variant-upsells__item variant-upsells__item-link">
    <span class="variant-upsells__media">
      <img src="{{IMG_SRC}}" alt="{{IMG_ALT}}" width="90" height="90">
    </span>
    <span class="variant-upsells__meta">
      <span class="variant-upsells__name" data-upsell-title>{{TITLE}}</span>
      <span class="variant-upsells__price" data-upsell-price>{{PRICE}}</span>
    </span>
  </a>
</div>`;

const quickviewTemplate = `<div class="quickview" x-data="productQuickViewButton({{PROD_ID}}, '{{PROD_HANDLE}}')">
<div data-quickview-holder="{{PROD_ID}}" data-add-action-wrapper data-error-boundry>
<div class="variant-upsells__item-wrap" data-variant-upsell>
<a class="variant-upsells__item-link" href="{{URL}}">

    <span class="variant-upsells__media">
      <img src="{{IMG_SRC}}" alt="{{IMG_ALT}}" width="90" height="90">
    </span>
    </a>
    <span class="variant-upsells__meta">
      <a class="variant-upsells__item-link" href="{{URL}}">

        <div class="variant-upsells__name" data-upsell-title>{{TITLE}}</div>
        <div class="variant-upsells__price" data-upsell-price>{{PRICE}}</div>
      </a>
      <div>
      <button
              class="product-clip__btn btn--soft btn--small btn--primary"
              type="button"
              @click.prevent="clickQuickviewButton"
              :class="{
                'loading': isLoading
              }"
              :disabled="isDisabled"
              :aria-busy="isLoading"
            >
              <span class="btn-state-ready">QUICK VIEW</span>
              <span class="btn-state-loading">
                <svg height="18" width="18" class="svg-loader">
                  <circle r="7" cx="9" cy="9" />
                  <circle stroke-dasharray="87.96459430051421 87.96459430051421" r="7" cx="9" cy="9" />
                </svg>
              </span>
            </button>
          </div>
    </span>
</div>
</div>
</div>`;

document.addEventListener('DOMContentLoaded', () => {
    const section = document.querySelector('[data-variant-upsells]');

    if ( section != null ) {
        if (section.dataset.inited === 'true') return;
        section.dataset.inited = 'true';

        const upsellData = section.querySelector('[data-variant-upsells-data]');
        const upsellList = section.querySelector('[data-variant-upsells-list]');

        if ( upsellData != null && upsellList != null ) {
            let layout = upsellList.getAttribute('data-upsell-layout');
            if ( layout == null ) {
                layout = 'checkbox'
            }

            renderForVariant( section.dataset.currentVariantId, layout )
        }

        function displayTitle( item ) {
            let title = "";

            if ( item.variant_title && item.variant_title !== 'Default Title' ) {
                title = item.variant_title
            } else {
                title = item.title
            }

            return title
        }

        function renderForVariant( variantId, isCheckbox ) {
            let data = JSON.parse(upsellData.textContent)
            const upsellList = section.querySelector('[data-variant-upsells-list]');

            if ( upsellList != null ) {
                const ids = data?.map?.[String(variantId)] || [];
                upsellList.innerHTML = '';
    
                if ( !ids.length ) {
                    section.hidden = true;
                    return
                }
                section.hidden = false;
    
                ids.forEach((upsellId) => {
                    const item = data.variants?.[String(upsellId)];
                    if (!item) return;

                    const deepLink = `${item.product_url}?variant=${item.id}`
    
                    let html = ""
                    if ( isCheckbox == 'checkbox' ) {
                        html = checkboxTemplate
                            .replaceAll('{{ID}}', item.id)
                            .replaceAll('{{TITLE}}', displayTitle(item))
                            .replaceAll('{{PRICE}}', item.price)
                            .replaceAll('{{IMG_SRC}}', item.image )
                            .replaceAll('{{IMG_ALT}}', item.title)
                            .replaceAll('{{URL}}', deepLink)
                    } else {
                        html = quickviewTemplate
                            .replaceAll('{{ID}}', item.id)
                            .replaceAll('{{TITLE}}', displayTitle(item))
                            .replaceAll('{{PRICE}}', item.price)
                            .replaceAll('{{IMG_SRC}}', item.image )
                            .replaceAll('{{IMG_ALT}}', item.title)
                            .replaceAll('{{PROD_ID}}', item.product_id)
                            .replaceAll('{{PROD_HANDLE}}', item.product_handle)
                            .replaceAll('{{URL}}', deepLink)
                    }
    
                    upsellList.insertAdjacentHTML("beforeend", html);     
    
                });
            }
        
        }

        document.addEventListener('theme:variant:change', (event) => {
            const variant = event?.detail?.variant;
            if (!variant?.id) return;

            let data = JSON.parse(upsellData.textContent)
            if ( data.map && String(variant.id) in data.map ) {
                section.dataset.currentVariantId = String(variant.id);
            }



            const upsellList = section.querySelector('[data-variant-upsells-list]');

            if ( upsellList != null ) {
                let layout = upsellList.getAttribute('data-upsell-layout');
                if ( layout == null ) {
                    layout = 'checkbox'
                }
                if ( data.map && String(variant.id) in data.map ) {
                    renderForVariant(variant.id, layout);
                }
            }
        });
    }
})

